import { FC } from 'react';
import exclamationMark from 'assets/images/exclamationMark.svg';
import { Modal } from 'components/Base/Modal';
import { ModalCentered } from 'components/Base/ModalCentered';
import { useTranslation } from '@packages/utils';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import SuccessModal from '../RegistrationModal/RegistrationModalForm/SuccessModal';
import { registrationModalKey } from '../RegistrationModal/RegistrationModal.data';
import { TRegistrationModalProps } from '../RegistrationModal/RegistrationModal.types';
import RegistrationContent from './components/RegistrationContent';
import useRegistrationContext from './context/NewRegistrationModalContext';

const RegistrationModal: FC<TRegistrationModalProps> = ({ open }) => {
  const { t } = useTranslation({
    keyPrefix: registrationModalKey,
    lng: 'translate',
  });
  const {
    handleClose,
    afterModalClose,
    isCapacityFull,
    handleSubmit,
    getRegistrationDataSuccess,
    isRegistrationLoading,
    eventFormData,
    openSuccessModal,
    setOpenSuccessModal,
    openWaitlistConfirmModal,
    setOpenWaitlistConfirmModal,
  } = useRegistrationContext();

  return (
    <>
      <ModalCentered
        title=""
        open={open}
        onCancel={handleClose}
        afterClose={afterModalClose}
        okText={t(isCapacityFull ? 'ADD_TO_WAITLIST' : 'REGISTER')}
        cancelText={t('CANCEL')}
        onOk={handleSubmit}
        isBodyFinallyRendered={getRegistrationDataSuccess}
        confirmLoading={isRegistrationLoading}
        width={1100}
        maskClosable={false}
        centeredPosition
        data-testid="registration-modal"
        data-cy="registration-modal"
      >
        <RegistrationContent eventDetailsData={eventFormData} />
      </ModalCentered>
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <Modal
        open={openWaitlistConfirmModal}
        width={400}
        okText={t('waitlist-confirmation.ADD_TO_WAITLIST_BTN')}
        onOk={handleSubmit}
        onCancel={() => {
          setOpenWaitlistConfirmModal(false);
        }}
        cancelText={t('waitlist-confirmation.CANCEL_BTN')}
        data-cy="waitlist-modal"
      >
        <ConfirmModalBody
          imgSrc={exclamationMark}
          title={t('waitlist-confirmation.TITLE')}
          description={t('waitlist-confirmation.DESCRIPTION')}
        />
      </Modal>
    </>
  );
};

export default RegistrationModal;
